import { Component } from '@angular/core';

@Component({
  selector: 'ngx-full-screen-layout',
  styleUrls: ['./full-screen.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class FullScreenLayoutComponent {}
